import { put, call } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import { FreeBoardPAppRepository } from '../../../../repositories';
import { fetchComments, addComment, deleteComment } from '../reducers';
import { digestResponse } from '../../../middlewares/response';

export function* watchFetchComments(action: ReturnType<typeof fetchComments>) {
  const { type, payload } = action;
  const { limit, page, postId, channelId } = payload;

  const response: AxiosResponse = yield call(() =>
    FreeBoardPAppRepository.findAllComments(postId, { limit, page }, channelId)
  );

  yield put(digestResponse(response, type));
}

export function* watchAddComment(action: ReturnType<typeof addComment>) {
  const { type, payload } = action;
  const { content, postId, channelId } = payload;

  const response: AxiosResponse = yield call(() =>
    FreeBoardPAppRepository.createComment(postId, { content }, channelId)
  );

  yield put(digestResponse(response, type));
}

export function* watchDeleteComment(action: ReturnType<typeof deleteComment>) {
  const { type, payload } = action;
  const { postId, commentId, channelId } = payload;

  const response: AxiosResponse = yield call(() =>
    FreeBoardPAppRepository.deleteComment({ postId, commentId }, channelId)
  );

  yield put(digestResponse(response, type));
}
